module.exports = __webpack_public_path__ + "img/sos-type-yellow.929ebacc.png";